import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/defaults";

const ContentContext = createContext({
    content: DEFAULT_CONTENT,
    loading: true,
    publishedAt: null,
    refresh: async () => {},
});

export const ContentProvider = ({ children, mode = "published" }) => {
    // mode = "published" | "draft" — draft only available with valid admin token
    const [content, setContent] = useState(DEFAULT_CONTENT);
    const [publishedAt, setPublishedAt] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const path = mode === "draft" ? "/admin/content/draft" : "/public/content";
            const { data } = await api.get(path);
            const fetched = mode === "draft" ? data.draft : data.content;
            // Merge with defaults so any new fields added in code keep working.
            setContent({ ...DEFAULT_CONTENT, ...(fetched || {}) });
            setPublishedAt(data.published_at || null);
        } catch {
            // Silently fall back to defaults on any error — page still works.
            setContent(DEFAULT_CONTENT);
        } finally {
            setLoading(false);
        }
    }, [mode]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <ContentContext.Provider value={{ content, loading, publishedAt, refresh }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => useContext(ContentContext);
